import { render, staticRenderFns } from "./ConcessionVerificationUserDrawer.vue?vue&type=template&id=d670ad78"
import script from "./ConcessionVerificationUserDrawer.vue?vue&type=script&lang=js"
export * from "./ConcessionVerificationUserDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports